import { takeEvery, put, call } from "redux-saga/effects"
import apiCall from "../services"

const apiUrl = process.env.REACT_APP_API_URL
const enviromentUrl = process.env.REACT_APP_ENVIROMENT

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie")
}

function* addReport(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    }

    let url = apiUrl + "/opa-reports"
    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions)


    if (typeof response === "string") {

      yield put({
        type: "REPORT_RESPONSE_ADD",
        value: {
          data: response,
          csvData: response,
          responseStatus: "success",
        },
      })
      return
    }

    if (response && typeof response === "object") {
      let responseStatus = "warning"

      if (response.data || response.csvData || response.createdAt || response.uuid || response.status === 200) {
        responseStatus = "success"
      } else if (response.error || response.status >= 400) {
        responseStatus = "error"
      }

      yield put({
        type: "REPORT_RESPONSE_ADD",
        value: {
          ...response,
          responseStatus,
        },
      })
      return
    }
    yield put({
      type: "REPORT_RESPONSE_ADD",
      value: {
        data: response,
        responseStatus: response ? "success" : "error",
      },
    })
  } catch (error) {
    yield put({
      type: "REPORT_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    })
  }
}

function* addReportTemplate(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    }

    let url = apiUrl + "/opa-reports-template"
    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "REPORT_TEMPLATE_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "REPORT_TEMPLATE_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
        message: error.message || "Error creating template",
      },
    })
  }
}

function* getReportsTemplatesList(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url =
      actions.query === null
        ? apiUrl + "/opa-reports-templates?page=" + actions.page
        : apiUrl + "/opa-reports-templates" + actions.query

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }


    const response = yield call(apiCall, "get", url, requestOptions)

    yield put({
      type: "LIST_REPORTS_TEMPLATES_RESPONSE_GET",
      value: response,
    })
  } catch (error) {
    yield put({
      type: "LIST_REPORTS_TEMPLATES_RESPONSE_GET",
      value: { error: error.message, responseStatus: "error" },
    })
  }
}

function* getReportTemplateId(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = `${apiUrl}/opa-reports-template/${actions.query}`
    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions)
    yield put({
      type: "REPORT_TEMPLATE_RESPONSE_GET",
      value: response,
    })
  } catch (error) {
    yield put({
      type: "REPORT_TEMPLATE_RESPONSE_GET",
      value: error,
    })
  }
}

function* updateReportTemplate(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const formData = { ...actions.form }
    if (formData.uuid) {
      delete formData.uuid
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    }

    let url = `${apiUrl}/opa-reports-template/${actions.uuid}`
    if (enviromentUrl !== "") {
      url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions)
    let responseStatus = "warning"
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "REPORT_TEMPLATE_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "REPORT_TEMPLATE_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* deleteReportTemplate(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = apiUrl + "/opa-reports-template/" + actions.uuid
    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions)
    let responseStatus = "warning"
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "REPORT_TEMPLATE_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    })
    return response
  } catch (error) {
    yield put({
      type: "REPORT_TEMPLATE_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    })
    throw error
  }
}

// Export functions with takeEvery
export function* addSagaReport() {
  yield takeEvery("ADD_REPORT", addReport)
}

export function* addSagaReportTemplate() {
  yield takeEvery("ADD_REPORT_TEMPLATE", addReportTemplate)
}

export function* getSagaReportsTemplatesList() {
  yield takeEvery("GET_LIST_REPORTS_TEMPLATES", getReportsTemplatesList)
}

export function* getSagaReportTemplateId() {
  yield takeEvery("GET_REPORT_TEMPLATE_ID", getReportTemplateId)
}

export function* updateSagaReportTemplate() {
  yield takeEvery("UPDATE_REPORT_TEMPLATE", updateReportTemplate)
}

export function* deleteSagaReportTemplate() {
  yield takeEvery("DELETE_REPORT_TEMPLATE", deleteReportTemplate)
}
